<template>
  <Card>
    <p slot="title">扫码记录列表</p>
    <template slot="extra">
      <Button type="primary" icon="md-cloud-upload" @click="exportAction()"
        >报表导出</Button
      >
      <Button type="primary" icon="ios-search" @click="handleSearch()"
        >查询</Button
      >
      <Button type="primary" icon="md-sync" @click="reset()">刷新</Button>
    </template>
    <Row>
      <Col span="24">
        <Select
          v-model="params.bgRpCode"
          placeholder="请选择大区"
          class="public-inp"
        >
          <!-- <Option
            v-for="(item, index) in provinceList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          > -->
        </Select>

        <Select
          v-model="params.provinceId"
          placeholder="请选择省份"
          class="public-inp"
          @on-change="provinceChange"
        >
          <Option
            v-for="(item, index) in provinceList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>

        <Select
          v-model="params.cityId"
          placeholder="请选择城市"
          class="public-inp"
        >
          <Option
            v-for="(item, index) in cityList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-model="params.channelCode"
          placeholder="请选择渠道"
          class="public-inp"
        >
          <Option
            v-for="(item, index) in channelList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>

        <Select
          v-model="params.grade"
          placeholder="请选择门店等级"
          class="public-inp"
        >
          <!-- <Option
            v-for="(item, index) in provinceList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          > -->
        </Select>

        <Input
          v-model="params.mdmCode"
          placeholder="请输入达能系统门店码"
          class="public-inp"
        />
        <Input
          v-model="params.qrCode"
          placeholder="请输入二维码编码"
          class="public-inp"
        />

        <Select
          v-model="params.state"
          placeholder="请选择校验结果"
          class="public-inp"
        >
          <!-- 校验结果，0-正常，1-未激活，2-失效，3-店码不符，4-不在发放清单中，5-物码不符 -->
          <Option value="0">正常</Option>
          <Option value="1">未激活</Option>
          <Option value="2">失效</Option>
          <Option value="3">店码不符</Option>
          <Option value="4">不在发放清单中</Option>
          <Option value="5">物码不符</Option>
        </Select>
        <DatePicker
          type="daterange"
          :options="options"
          placement="bottom-start"
          placeholder="请选择扫码时间"
          v-model="seTime"
          class="public-inp"
        ></DatePicker>
        <Input
          v-model="params.storeId"
          placeholder="请输入门店ID"
          class="public-inp"
        />
        <Input
          v-model="params.srId"
          placeholder="请输入人员编号"
          class="public-inp"
        />
        <Select
          v-model="params.roleTypeCode"
          placeholder="请选择角色"
          class="public-inp"
        >
          <!-- <Option
            v-for="(item, index) in provinceList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          > -->
        </Select>
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ index }" slot="sort">
            {{ (params.pageNum - 1) * params.pageSize + index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="javascript:;" @click="toDetail(row)">查看</a>
          </template>
        </Table>
        <Page
          :total="total"
          :page-size="params.pageSize"
          :current="params.pageNum"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class="public-page"
        />
      </Col>
    </Row>
  </Card>
</template>

<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    fixed: "left",
    width: 66,
  },
  {
    title: "二维码编码",
    key: "qrCode",
    width: 100,
  },
  {
    title: "渠道",
    key: "channelCode",
    width: 100,
  },
  {
    title: "门店等级",
    key: "grade",
    width: 100,
  },
  {
    title: "达能系统门店码",
    key: "mdmCode",
    width: 100,
  },
  {
    title: "大区",
    key: "bgRpName",
    width: 100,
  },
  {
    title: "省份",
    key: "provinceName",
    width: 100,
  },
  {
    title: "城市",
    key: "cityName",
    width: 100,
  },
  {
    title: "门店ID",
    key: "retCode",
    width: 100,
  },
  {
    title: "门店名称",
    key: "retName",
    width: 100,
  },
  {
    title: "门店类型",
    key: "retType",
    width: 100,
  },
  {
    title: "父级门店ID",
    key: "parentRetCode",
    width: 100,
  },

  {
    title: "物料名称",
    key: "name",
    width: 100,
  },
  {
    title: "校验人",
    key: "srName",
    width: 100,
  },
  {
    title: "人员编码",
    key: "srId",
    width: 100,
  },
  {
    title: "角色",
    key: "roleType",
    width: 100,
  },

  {
    title: "扫码时间",
    key: "scanTime",
    width: 100,
  },
  {
    title: "扫码经度",
    key: "longitude",
    width: 100,
  },
  {
    title: "扫码纬度",
    key: "latitude",
    width: 100,
  },
  {
    title: "距离激活位置距离",
    key: "distance",
    width: 100,
  },
  {
    title: "校验结果",
    key: "state",
    width: 100,
    render(h, params) {
      // 0-正常，1-未激活，2-失效，3-店码不符，4-不在发放清单中，5-物码不符
      let s = params.row.state,
        t = "";
      switch (s) {
        case "0":
          t = "正常";
          break;
        case "1":
          t = "未激活";
          break;
        case "2":
          t = "失效";
          break;
        case "3":
          t = "店码不符";
          break;
        case "4":
          t = "不在发放清单中";
          break;
        case "5":
          t = "物码不符";
          break;
        default:
          t = "";
      }
      return h("span", t);
    },
  },
  {
    title: "操作",
    slot: "action",
    fixed: "right",
    width: 130,
  },
];
const options = {
  shortcuts: [
    {
      text: "1 week",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      },
    },
    {
      text: "1 month",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      },
    },
    {
      text: "3 months",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        return [start, end];
      },
    },
  ],
};
export default {
  data() {
    return {
      channelList: [
        { name: "GT", code: "GT" },
        { name: "KA", code: "KA" },
        { name: "OTHERS", code: "OTHERS" },
      ],
      options,
      params: {
        bgRpCode: "",
        channelCode: "",
        cityId: "",
        grade: "",
        mdmCode: "",
        provinceId: "",
        qrCode: "",
        roleTypeCode: "",
        scanTimeBegin: "",
        scanTimeEnd: "",
        srId: "",
        state: "",
        storeId: "",
        pageNum: 1,
        pageSize: 10,
      },
      seTime: [],
      total: 0,
      columns,
      tbList: [],
      loading: false,
      provinceList: [],
      cityList: [],
    };
  },
  created() {
    this.getList();
    this.getBaseAreaQueryAll();
  },
  methods: {
    handleSearch() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.getList();
    },
    provinceChange(e) {
      let data = this.provinceList,
        cityList = [];
      this.params.cityId = "";
      data.map((item) => {
        item.children.forEach((i0) => {
          if (this.params.provinceId && this.params.provinceId == i0.parent) {
            cityList.push(i0);
          }
        });
      });
      this.cityList = cityList;
    },
    getBaseAreaQueryAll() {
      this.$api.areaQueryAll().then((res) => {
        if (res.code == 200) {
          let cityList = [];
          this.provinceList = res.data;
          res.data.map((item) => {
            item.children.forEach((i0) => {
              cityList.push(i0);
            });
          });
          this.cityList = cityList;
        }
      });
    },
    initTime(t, i) {
      if (!t[i]) {
        return "";
      }
      let d = t[i];
      let str = new Date(d);
      return this.tools.formatDate(str, true);
    },
    getList() {
      this.loading = true;
      let params = this.params;
      params.scanTimeBegin = this.initTime(this.seTime, 0);
      params.scanTimeEnd = this.initTime(this.seTime, 1);
      this.$api.scanList(params).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.tbList = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 页码
    pageChange(d) {
      this.params.pageNum = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.params.pageSize = d;
      this.getList();
    },
    // 重置
    reset() {
      for (let key in this.params) {
        this.params[key] = "";
      }
      this.seTime = [];
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    toDetail(e) {
      this.$router.push({
        path: "scanDetail",
        query: {
          code: e.code,
        },
      });
    },
    exportAction() {
      let data = this.params;
      this.$api.scanExport(data).then((res) => {
        if (res.code == "200") {
          try {
            let elemIF = document.createElement("iframe");
            elemIF.src = res.data.url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
          } catch (e) {
            this.$Message.error("下载异常！");
          }
        } else {
          this.$Message.error("导出失败" + res.message);
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/material/scanList.vue